import React from 'react';

import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { IconWrapper, Input, Wrapper } from './styles';

interface SearchFieldProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

// Busca ao lado dos filtros da própria tela, em vez de fixa no topo do
// Painel (que só fazia sentido quando era a única forma de filtrar --
// agora que toda tela com busca já tem select de filtro, os dois
// juntos ficam mais claros que um separado do outro).
const SearchField: React.FC<SearchFieldProps> = ({
  placeholder,
  value,
  onChange,
}) => (
  <Wrapper>
    <IconWrapper>
      <Icon name="search" size={18} color={colors.onSurfaceVariant} />
    </IconWrapper>
    <Input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  </Wrapper>
);

export { SearchField };
